import React from 'react';
import {type IconDefinition} from '@netx/core-icons';
import {Button, type ButtonProps} from '@netx/core-components/Button';
import {
	FallbackMessage,
	type FallbackMessageProps,
} from '@netx/core-components/FallbackMessage';
import {styled} from '@netx/core-components/Theme';

const EmptyStateFallbackContent = styled('div')(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	'& button + button': {
		marginTop: theme.spacing(1),
	},
}));

export interface EmptyStateFallbackMessageProps extends FallbackMessageProps {
	actionButtonIcon?: IconDefinition;
	actionButtonLabel?: string;
	secondaryActionButtonIcon?: IconDefinition;
	secondaryActionButtonLabel?: string;
	onActionButtonClick?: ButtonProps['onClick'];
	onSecondaryActionButtonClick?: ButtonProps['onClick'];
}

export const EmptyStateFallbackMessage = ({
	children,
	actionButtonIcon,
	actionButtonLabel,
	secondaryActionButtonIcon,
	secondaryActionButtonLabel,
	onActionButtonClick,
	onSecondaryActionButtonClick,
	...props
}: EmptyStateFallbackMessageProps) => {
	return (
		<FallbackMessage variant="light" {...props}>
			{children}
			{(onActionButtonClick != null ||
				onSecondaryActionButtonClick != null) && (
				<EmptyStateFallbackContent>
					{onActionButtonClick != null && (
						<Button
							startIcon={actionButtonIcon}
							variant="outlined"
							onClick={onActionButtonClick}
						>
							{actionButtonLabel}
						</Button>
					)}
					{onSecondaryActionButtonClick != null && (
						<Button
							startIcon={secondaryActionButtonIcon}
							variant="text"
							onClick={onSecondaryActionButtonClick}
						>
							{secondaryActionButtonLabel}
						</Button>
					)}
				</EmptyStateFallbackContent>
			)}
		</FallbackMessage>
	);
};

export default EmptyStateFallbackMessage;
